import { Link } from 'react-router-dom';

const footerLinks = {
  categories: [
    { name: '黑料一区', path: '/category/zone1' },
    { name: '黑料二区', path: '/category/zone2' },
    { name: '每日大赛专区', path: '/category/contest' },
  ],
  pages: [
    { name: '关于我们', path: '/about' },
    { name: '品牌介绍', path: '/about#brand' },
    { name: '联系方式', path: '/about#contact' },
  ],
  legal: [
    { name: '用户协议', path: '/about#terms' },
    { name: '隐私政策', path: '/about#privacy' },
    { name: '免责声明', path: '/about#disclaimer' },
  ],
};

export default function Footer() {
  return (
    <footer className="bg-background-100 border-t border-background-200/60">
      <div className="w-full px-4 md:px-6 py-10 md:py-14">
        <div className="max-w-7xl mx-auto">
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-8">
            {/* Brand */}
            <div className="lg:col-span-1">
              <Link to="/" className="flex items-center gap-2 mb-4">
                <div className="w-8 h-8 flex items-center justify-center rounded-lg bg-accent-500">
                  <span className="font-heading text-base font-bold text-foreground-50">51</span>
                </div>
                <span className="font-heading text-lg font-semibold text-foreground-50">黑料网</span>
              </Link>
              <p className="text-sm text-foreground-400 leading-relaxed">
                51黑料网分区导航平台，提供一区二区及每日大赛专区的最新内容，按区浏览黑料动态，获取第一手资讯。
              </p>
            </div>

            {/* Category Links */}
            <div>
              <h4 className="font-heading text-sm font-semibold text-foreground-200 uppercase tracking-wider mb-4">
                分区导航
              </h4>
              <ul className="space-y-2.5">
                {footerLinks.categories.map((link) => (
                  <li key={link.path}>
                    <Link
                      to={link.path}
                      className="text-sm text-foreground-400 hover:text-primary-500 transition-colors whitespace-nowrap"
                    >
                      {link.name}
                    </Link>
                  </li>
                ))}
              </ul>
            </div>

            {/* Page Links */}
            <div>
              <h4 className="font-heading text-sm font-semibold text-foreground-200 uppercase tracking-wider mb-4">
                关于本站
              </h4>
              <ul className="space-y-2.5">
                {footerLinks.pages.map((link) => (
                  <li key={link.path}>
                    <Link
                      to={link.path}
                      className="text-sm text-foreground-400 hover:text-primary-500 transition-colors whitespace-nowrap"
                    >
                      {link.name}
                    </Link>
                  </li>
                ))}
              </ul>
            </div>

            {/* Legal Links */}
            <div>
              <h4 className="font-heading text-sm font-semibold text-foreground-200 uppercase tracking-wider mb-4">
                法律声明
              </h4>
              <ul className="space-y-2.5">
                {footerLinks.legal.map((link) => (
                  <li key={link.path}>
                    <Link
                      to={link.path}
                      className="text-sm text-foreground-400 hover:text-primary-500 transition-colors whitespace-nowrap"
                    >
                      {link.name}
                    </Link>
                  </li>
                ))}
              </ul>
            </div>
          </div>

          {/* Bottom bar */}
          <div className="mt-10 pt-6 border-t border-background-200/40 flex flex-col sm:flex-row items-center justify-between gap-3">
            <p className="text-xs text-foreground-500">
              &copy; {new Date().getFullYear()} 51黑料网 版权所有 | 本站内容仅供信息参考
            </p>
            <p className="text-xs text-foreground-600">
              51黑料网 | 一区二区 | 每日大赛 | 黑料分区导航
            </p>
          </div>
        </div>
      </div>
    </footer>
  );
}